import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { pollingIntervalAtom } from '@/store/polling-atoms';

/**
 * 动态设置轮询间隔
 * Dynamically set polling interval
 *
 * 自动更新 Jotai atom，atomWithStorage 自动持久化到 localStorage
 * Automatically updates Jotai atom, atomWithStorage automatically persists to localStorage
 *
 * @param interval - 轮询间隔（毫秒）(Polling interval in milliseconds)
 * @param deps - 依赖数组（可选）(Dependency array, optional)
 *
 * @example
 * ```typescript
 * // 游戏中使用 5 秒间隔 (Use 5 second interval in game)
 * const { isInGame } = useGameScenario();
 * usePollingInterval(isInGame ? 5000 : 10000);
 * ```
 */
export function usePollingInterval(interval: number, deps: any[] = []) {
  const setInterval = useSetAtom(pollingIntervalAtom);

  useEffect(() => {
    // 更新 atom（React Query 会自动响应）
    // Update atom (React Query will automatically respond)
    // atomWithStorage 自动保存到 localStorage
    // atomWithStorage automatically saves to localStorage
    setInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interval, setInterval, ...deps]);
}
